export default __webpack_public_path__ + "static/media/barDown.svg";